/* eslint-disable import/no-anonymous-default-export */
// import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { get, size } from 'lodash';
import { CAP_NHAT_KHIEU_NAI, CREATE_KHIEU_NAI, DONG_KHIEU_NAI, GET_CHI_TIET_KHIEU_NAI, GET_LIST_KHIEU_NAI, GET_LIST_KHIEU_NAI_THEO_USER, PHAN_HOI_KHIEU_NAI } from './constant';
import { getDetailKhieuNaiApi, getListKhieuNaiApi, getListKhieuNaiByUserApi, postCloseKhieuNai, postCreateKhieuNaiApi, postReplyKhieuNaiApi, postUpdateKhieuNaiApi } from './helpers';
import { ActionGetDanhSachKhieuNaiDone, ActionGetListKNByUserDone } from './action';

function* takeGetListKhieuNaiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getListKhieuNaiApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
      yield put(ActionGetDanhSachKhieuNaiDone(data));
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostCraeteKhieuNaiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postCreateKhieuNaiApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetListDetailKhieuNaiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getDetailKhieuNaiApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostCloseKhieuNaiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postCloseKhieuNai, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostReplyKhieuNaiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postReplyKhieuNaiApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostUpdateKhieuNaiSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postUpdateKhieuNaiApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetListKhieuNaiByUserSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getListKhieuNaiByUserApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
      yield put(ActionGetListKNByUserDone(data));
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error, 'response.data', ''));
  } finally {
    action.callback?.onFinish?.()
  }
}

export default function* () {
  yield takeLatest(GET_LIST_KHIEU_NAI, takeGetListKhieuNaiSaga);
  yield takeLatest(CREATE_KHIEU_NAI, takePostCraeteKhieuNaiSaga);
  yield takeLatest(GET_CHI_TIET_KHIEU_NAI, takeGetListDetailKhieuNaiSaga);
  yield takeLatest(DONG_KHIEU_NAI, takePostCloseKhieuNaiSaga);
  yield takeLatest(PHAN_HOI_KHIEU_NAI, takePostReplyKhieuNaiSaga);
  yield takeLatest(CAP_NHAT_KHIEU_NAI, takePostUpdateKhieuNaiSaga);
  yield takeLatest(GET_LIST_KHIEU_NAI_THEO_USER, takeGetListKhieuNaiByUserSaga);
}

